<script>

export default {
    render: function (createElement) {
        let style = this.$store.state.roles.map(role=>`[${role}]{display: ${this.mapAccess(role) <= this.mapAccess(this.role) ? 'initial':'none'};} [not-${role}]{display: ${this.mapAccess(role) > this.mapAccess(this.role) ? 'initial':'none'};}`).join('\n');
        return createElement('style', style)
    },
    props: ['role'],
    methods: {
        mapAccess(name){
            return this.$store.state.roles.indexOf(name);
        }
    },
    data: function(){
        return {
            
        }
    }
}

</script>
